/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { Text } from '@chakra-ui/react';
import { PlatformTextComponent } from '@karya/core';
import { ParsedParams } from '@karya/generic-task-react';

export function PlatformTextRenderer({ params }: { params: ParsedParams<any> }) {
  const typedParams = params as ParsedParams<PlatformTextComponent>;
  return <Text fontSize="sm">{typedParams.text ?? 'Sample Text'}</Text>;
}
